import React, { useEffect, useState } from "react";
import { Instagram, Phone, Sparkles } from "lucide-react";
import { PHONE, INSTAGRAM, buildWhatsAppLink } from "../data/menu";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#FFF0F3]/75 border-b border-[#3E2723]/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-4 flex items-center justify-between">
        <a
          href="#hero"
          data-testid="nav-logo"
          className="flex items-center gap-2 buffy-link"
        >
          <span className="w-9 h-9 rounded-full bg-[#3E2723] text-[#FFF0F3] grid place-items-center font-display font-black text-lg">
            B
          </span>
          <span className="font-display font-black text-xl text-[#3E2723]">
            Buffy&rsquo;s
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8 font-body text-sm text-[#3E2723]/80">
          <a
            href="#menu"
            data-testid="nav-menu"
            className="hover:text-[#3E2723] transition-colors"
          >
            Menú
          </a>
          <a
            href="#historia"
            data-testid="nav-historia"
            className="hover:text-[#3E2723] transition-colors"
          >
            Nuestra historia
          </a>
          <a
            href="#contacto"
            data-testid="nav-contacto"
            className="hover:text-[#3E2723] transition-colors"
          >
            Contacto
          </a>
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={`https://instagram.com/${INSTAGRAM}`}
            target="_blank"
            rel="noreferrer"
            data-testid="nav-instagram"
            aria-label="Instagram Buffy's"
            className="hidden sm:grid w-10 h-10 place-items-center rounded-full bg-[#FFFDF9] border border-[#3E2723]/10 text-[#3E2723] buffy-link hover:bg-[#FDF8E1]"
          >
            <Instagram size={18} />
          </a>
          <a
            href={buildWhatsAppLink()}
            target="_blank"
            rel="noreferrer"
            data-testid="nav-order-cta"
            className="inline-flex items-center gap-2 rounded-full bg-[#3E2723] text-[#FFF0F3] px-4 sm:px-5 py-2.5 text-sm font-bold buffy-link shadow-[0_10px_25px_rgba(62,39,35,0.25)] hover:shadow-[0_14px_35px_rgba(62,39,35,0.35)]"
          >
            <Sparkles size={16} />
            <span className="hidden sm:inline">Pedir ahora</span>
            <span className="sm:hidden">Pedir</span>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
